module.exports = __webpack_public_path__ + "f27a72499a8273247bfdf607dc7e08f3.png";